// extracted by mini-css-extract-plugin
export default {"text-input":"KVTtTHM","text-input__element":"XmJSDy6","text-input__label":"R5VVhi7","text-input__icon":"HkD2k9e","text-input__input-message":"W0Y8M2L","text-input--error":"b8iocDZ"};